
import * as React from "react"

function App() {
  // const [isAcceptAge, setIsAcceptAge] = React.useState(false)

  // React.useEffect(() => {
  //   const age = window.localStorage.getItem("ageGateValidate")
    
  //   if (age) setIsAcceptAge(true)
  // }, [])

  return (
    <>

      {/* Page HTML */}

      <section id='king-rubigol'>

        {/* {
          isAcceptAge && (
            <div className= {`${isAcceptAge ? 'loader' : ''} loader-menu`}>
              <span className='loader-value'>0%</span>
            </div>
          )
        } */}
        <div className='loader loader-rubigol'>
          <span className='loader-value hidden'>0%</span>
        </div>
        <canvas id='canvas-rubigol'></canvas>

      </section>
    </>
  )
}

export default App
